
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/building-a-home-important-prep-steps",
      function () {
        return require("private-next-pages/articles/building-a-home-important-prep-steps.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/building-a-home-important-prep-steps"])
      });
    }
  